import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../store';
import MediaPickerLoadMoreCard from '../../common/MediaPickerLoadMoreCard';
import MediaPickersConstants from '../../MediaPickersConstants';

const ImageElementAssetImagesLoadMoreCard = ({
    imageElementAssetsPageNumber,
    imageElementAssetsLoading,
    galleryCardWidth,
    galleryCardHeight,
    loadUserImageElementAssets
}) => {
    const onLoadMoreButtonClick = () => {
        loadUserImageElementAssets(imageElementAssetsPageNumber + 1, MediaPickersConstants.USER_ASSETS_PER_PAGE);
    };

    return (
        <MediaPickerLoadMoreCard
            key={'load-more-button'}
            onLoadMoreButtonClick={onLoadMoreButtonClick}
            isLoading={imageElementAssetsLoading}
            galleryCardWidth={galleryCardWidth}
            galleryCardHeight={galleryCardHeight}
        />
    );
};

const mapStateToProps = (state) => {
    const {
        imageElementAssetsPageNumber,
        imageAssetsPageNumber,
        imageElementAssetsLoading,
        imageAssetsLoading
    } = state.mediaPicker;

    return {
        imageElementAssetsPageNumber: imageElementAssetsPageNumber ?? imageAssetsPageNumber ?? 1,
        imageElementAssetsLoading: imageElementAssetsLoading ?? imageAssetsLoading ?? false
    };
};

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const loadUserImageElementAssets = (pageNumber, itemsPerPage) => dispatch(mediaPickerActions.loadUserImageElementAssets(pageNumber, itemsPerPage));

    return {
        setProperty,
        loadUserImageElementAssets
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageElementAssetImagesLoadMoreCard);
